<div class="network-status-badge" [class]="statusDisplay().class" [tippy]="statusDisplay().tooltip"
  [tippyProps]="tippyPropsObj" data-testid="network-status-badge">
  <span class="status-icon" [attr.aria-label]="statusDisplay().label">
    {{ statusDisplay().icon }}
  </span>
  <span class="status-label">{{ statusDisplay().label }}</span>
</div>